/**
 * @generated SignedSource<<602312f524c5b4e6aef3076674a025b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type StationLinksList_stations$data = {
  readonly items: ReadonlyArray<{
    readonly stationId: number
    readonly isMain: boolean
    readonly name: string
    readonly cemeteryCount: number
  }>
  readonly ' $fragmentType': 'StationLinksList_stations'
}
export type StationLinksList_stations$key = {
  readonly ' $data'?: StationLinksList_stations$data
  readonly ' $fragmentSpreads': FragmentRefs<'StationLinksList_stations'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'StationLinksList_stations',
  selections: [
    {
      alias: null,
      args: null,
      concreteType: 'StationWithCemeteryCount',
      kind: 'LinkedField',
      name: 'items',
      plural: true,
      selections: [
        {
          alias: 'stationId',
          args: null,
          kind: 'ScalarField',
          name: 'id',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'isMain',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'name',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'cemeteryCount',
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'StationWithCemeteryCountConnection',
  abstractKey: null
}

;(node as any).hash = '56f9774d133a9bddb83af4b20495de0f'

export default node
